import React, { Component } from 'react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import get from 'lodash.get'
import queryString from 'query-string'
import { Collapse } from 'react-bootstrap'
import store from 'store2'

import Alert from '../../../../components/alert'
import Col from '../../../../components/col'
import ListingSearchForm from '../../../../components/listingSearchForm'
import Row from '../../../../components/row'
import LoginLink from '../../../../components/loginLink'

import TRACKING_EVENTS from '../../../../constants/trackingEvents'

import { translate } from '../../../../helpers/stringHelpers'
import { millisToLocaleString, DateTime } from '../../../../helpers/dateHelpers'

import List from '../../../../components/list'
import ListItem from '../../../../components/listItem'
import { faCaretDown, faCaretRight, faTh, faThList } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SocialLinks from '../../../../components/socialLinks'
import Button from '../../../../components/button'
import StripeCheckoutButton from '../../../../components/stripeCheckoutButton'
import MediaQuery from 'react-responsive'
import ListingListItem from '../../../../components/listingListItem'
import ButtonGroup from '../../../../components/buttonGroup'
import Badge from '../../../../components/badge'
import PreferenceContext from '../../../../contexts/userPreferenceContext'
import { trackEvent } from '../../../../withTracking'
import PaginationContainer from '../../../../components/paginationContainer/paginationContainer'

const {
  CATEGORY_AUCTION,
  CATEGORY_USER,
  ACTION_CHANGE_LAYOUT,
  ACTION_CHANGE_PAGESIZE,
  ACTION_FILTER_SEARCH,
  ACTION_FILTER_STATUS_ALL,
  ACTION_FILTER_STATUS_WINNING,
  ACTION_FILTER_STATUS_LOSING,
  ACTION_FILTER_CATEGORY,
  ACTION_FILTER_COUNTRY,
  ACTION_FILTER_STARRED,
  ACTION_FILTER_OPEN,
  ACTION_VIEW_PAGE
} = TRACKING_EVENTS

const collatorCompare = Intl.Collator().compare
const sortByLabel = (a, b) => collatorCompare(a.label, b.label)

export class TimedList extends Component {
  static contextType = PreferenceContext
  _query = {}

  constructor (props) {
    super(props)
    this.state = {
      expandFilter: false,
      isListLayout: store.get('bidJS__list-layout') || false
    }
  }

  _getAuctionUuid = () => this.props.isMarketplace ? 'marketplace' : this.props.uuid

  toggleFilter = () => {
    this.setState({
      expandFilter: !this.state.expandFilter
    })
  }

  sortByAuctionIndex = (a, b) => {
    if (!a || !b) return null
    return this.props.listings[a]?.auctionIndex - this.props.listings[b]?.auctionIndex
  }

  getItemsPerPagePreference = () => parseInt(this._query.ic) || parseInt(store.get('bidJS__items-per-page')) || this.props.itemsPerPageDefault

  setItemsPerPagePreference = (itemCount) => {
    this._query.ic = itemCount
    store('bidJS__items-per-page', itemCount)
    trackEvent(CATEGORY_AUCTION, ACTION_CHANGE_PAGESIZE, itemCount)
    this.updateQueryParams()
  }

  handleContinentFilterSelection = (opts) => {
    const newValue = (opts && opts.map(opt => opt.value)) || []
    this._query.loc = newValue.join()
    delete this._query.page
    trackEvent(CATEGORY_AUCTION, ACTION_FILTER_COUNTRY, this._getAuctionUuid())
    this.updateQueryParams()
  }

  handleCategoryFilterSelection = (opts) => {
    const newValue = (opts && opts.map(opt => opt.value)) || []
    this._query.cat = newValue.join()
    delete this._query.page
    trackEvent(CATEGORY_AUCTION, ACTION_FILTER_CATEGORY, this._getAuctionUuid())
    this.updateQueryParams()
  }

  handleFilterSelection = (filterKey, value) => {
    if (filterKey === 'filterOpenOnly') {
      this._query.open = value
      delete this._query.page
      trackEvent(CATEGORY_AUCTION, ACTION_FILTER_OPEN, this._getAuctionUuid())
    }
    this.updateQueryParams()
  }

  handleBidStatusFilterUpdate = (status = '') => {
    this._query.bstatus = status
    delete this._query.page
    const eventAction = (status === '' && ACTION_FILTER_STATUS_ALL) ||
      (status === 'w' && ACTION_FILTER_STATUS_WINNING) ||
      (status === 'l' && ACTION_FILTER_STATUS_LOSING) ||
      (status === 's' && ACTION_FILTER_STARRED)
    trackEvent(CATEGORY_AUCTION, eventAction, this._getAuctionUuid())
    this.updateQueryParams()
  }

  handleFiltersReset = () => {
    delete this._query.bstatus
    delete this._query.open
    delete this._query.search
    delete this._query.loc
    delete this._query.cat
    delete this._query.page
    this.updateQueryParams()
  }

  handleSearchStringUpdate = (e) => {
    const searchString = e.target.value
    this._query.search = searchString
    delete this._query.page
    trackEvent(CATEGORY_AUCTION, ACTION_FILTER_SEARCH, this._getAuctionUuid())
    this.updateQueryParams()
  }

  handlePagination = (pageNumber) => {
    trackEvent(CATEGORY_AUCTION, ACTION_VIEW_PAGE, this._getAuctionUuid(), pageNumber)
    const element = document.getElementsByClassName('auction__results-count')
    element[0]?.scrollIntoView(true)
  }

  updateQueryParams = () => {
    const query = queryString.stringify(this._query)
    this.props.history.replace(`${this.props.match.url}?${query}`)
  }

  scrollToFocus = () => {
    if (this._query.focus) {
      const listing = this.props.listings[this._query.focus]
      if (listing) {
        const elementToScrollTo = document.getElementById(`timed-listing__${listing.lotNumber}`)
        if (elementToScrollTo) {
          elementToScrollTo.scrollIntoView(true)
        }
      }
      delete this._query.focus
      const query = queryString.stringify(this._query)
      this.props.history.replace(`${this.props.match.url}?${query}`)
    }
  }

  setLayoutPreference = (isListLayout = false) => {
    this.setState({
      isListLayout
    })
    store('bidJS__list-layout', isListLayout)
    trackEvent(CATEGORY_USER, ACTION_CHANGE_LAYOUT, isListLayout ? 'List' : 'Gallery')
  }

  componentDidMount = () => {
    this.scrollToFocus()
    this.setItemsPerPagePreference(this.getItemsPerPagePreference())
    this.props.listingUuids.sort(this.sortByAuctionIndex)
  }

  componentDidUpdate = () => {
    this.scrollToFocus()
  }

  render () {
    const auctionUuid = this._getAuctionUuid()
    const auctionId = this.props.auctions[auctionUuid].id
    const auction = this.props.auctions[auctionUuid]
    const auctionInformation = this.props.informations && this.props.informations[auctionUuid]
    this._query = queryString.parse(this.props.location.search)
    this.props.listingUuids.sort(this.sortByAuctionIndex)

    const userUuid = this.props.userUuid

    const page = this._query.page || 1
    const isShowingStarOnly = this._query.star === 'true'
    const isShowingOpenOnly = this._query.open === 'true'
    const filterCategories = this._query.cat ? this._query.cat.split(',') : []
    const filterLocations = this._query.loc ? this._query.loc.split(',') : []
    const filterString = this._query.search || ''
    // pagination
    const listingsPerPage = this.getItemsPerPagePreference()
    const listingCount = this.props.listingUuids.length
    const pageNumber = Math.min(page, Math.ceil(listingCount / listingsPerPage))
    const previousListings = (pageNumber - 1) * listingsPerPage
    const currentListingCountStart = previousListings + 1
    const currentListingCountEnd = Math.min(listingCount, previousListings + listingsPerPage)
    const paginationText = translate('JspPublicCodes_JSP_PAGINATION_OF')
      .replace('{0}', currentListingCountStart)
      .replace('{1}', currentListingCountEnd)
      .replace('{2}', listingCount)
    const hasPagination = listingCount && listingsPerPage < auction.activeListings.length
    const enablePaginationTop = this.props.enablePaginationTop
    const nonGroupedListings = this.props.listingUuids.filter(uuid => !this.props.listings[uuid].grouped)
    const paginatedNonGroups = (hasPagination)
      ? nonGroupedListings.slice(previousListings, currentListingCountEnd)
      : nonGroupedListings
    const paginatedFilteredListings = (hasPagination)
      ? this.props.listingUuids.slice(previousListings, currentListingCountEnd)
      : this.props.listingUuids
    const listingsByCategoryUuid = this.props.listingsByCategoryUuid?.[auctionUuid]
    const listingsByLocation = this.props.listingsByLocation?.[auctionUuid]

    const queryInterpole = queryString.stringify(Object.assign({}, this._query, {
      page: '{page}'
    }))
    const paginationUrl = `${this.props.match.url}?${queryInterpole}`

    const categoryToOption = categoryChildUuid => ({
      label: this.props.childCategories[categoryChildUuid].name,
      count: listingsByCategoryUuid[categoryChildUuid]
        ? listingsByCategoryUuid[categoryChildUuid].length
        : 0,
      value: categoryChildUuid
    })

    const locationToOption = locationKey => ({
      label: this.props.countries[locationKey],
      value: locationKey
    })

    const searchCategories = this.props.auctionCategories[auctionUuid] && this.props.auctionCategories[auctionUuid]
      .map(parentUuid => {
        const category = this.props.parentCategories[parentUuid]
        return {
          label: category.name,
          options: category.children
            ? category.children
              .map(categoryToOption)
              .filter(option => option.count)
              .sort(sortByLabel)
            : null,
          value: parentUuid
        }
      }).sort(sortByLabel)

    const locations = listingsByLocation
      ? Object.keys(listingsByLocation)
        .map(locationToOption)
        .sort(sortByLabel)
      : []

    const listingSearchForm = (
      <ListingSearchForm
        categories={searchCategories}
        countries={locations}
        onFilterSelection={this.handleFilterSelection}
        onSearchInputChange={this.handleSearchStringUpdate}
        isFavouriteOnly={isShowingStarOnly}
        isOpenOnly={isShowingOpenOnly}
        onCategorySelection={this.handleCategoryFilterSelection}
        onCountrySelection={this.handleContinentFilterSelection}
        searchValue={filterString}
        selectedCategories={filterCategories
          .map(categoryToOption)}
        selectedCountries={filterLocations
          .map(locationToOption)}
      />
    )
    const listingListItems = (listingsArray) => {
      return listingsArray.map((listingUuid) => {
        return <ListingListItem
          key={`listing${listingUuid}`}
          listingUuid={listingUuid}
          hasStarted={this.props.hasStarted}
          query={this.props.location.search}
          lotNumber={this.props.listings[listingUuid].lotNumber}
          currentLanguageCode={this.props.currentLanguageCode}
        />
      })
    }

    const pageURL = get(window, 'location.href')
    // We don't show the registration button on Marketplace, since Marketplace can consist of several auctions
    const registration = userUuid && this.props.registrantsByUserUuid[auctionUuid]?.[userUuid]

    const hasFilters = (this._query.bstatus && this._query.bstatus !== 'all' && this._query.bstatus !== '') ||
      (this._query.open && this._query.open !== 'false') ||
      !!this._query.search || this._query.loc || this._query.cat

    const handleFilterClick = () => this.toggleFilter()
    return (
      <section aria-label='Auction Listings'>
        <header className='timed-auction__heading'>
          <Row>
            <Col xs={12} sm={8}>
              <h1 className='timed-heading__title page__title h3'>{this.props.isMarketplace
                ? translate('PageCodes_PAGE_MARKETPLACE_TITLE')
                : auction.title
              }</h1>
              {!this.props.isMarketplace
                ? (
                  <h4 className='timed-heading__times timed-heading__times--start h5 text-muted'>
                    <strong>
                      {translate('JspPublicCodes_JSP_TIMED_AUCTION_STARTS')}
                    </strong>
                    {' '}{millisToLocaleString(auction.startsAt, null, { ...DateTime.DATETIME_MED_WITH_WEEKDAY, timeZoneName: 'short' })}
                  </h4>
                  )
                : null}
              {!this.props.isMarketplace && auction.endsAt
                ? (
                  <h4 className='timed-heading__times timed-heading__times--end h5 text-muted'>
                    <strong>
                      {translate('JspPublicCodes_JSP_TIMED_AUCTION_ENDS')}
                    </strong>
                    {' '}{millisToLocaleString(auction.endsAt, null, { ...DateTime.DATETIME_MED_WITH_WEEKDAY, timeZoneName: 'short' })}
                  </h4>)
                : null}
              <p className='timed-heading__description' dangerouslySetInnerHTML={{ __html: this.props.isMarketplace ? translate('PageCodes_PAGE_MARKETPLACE') : auctionInformation?.description }} />
            </Col>
            <Col xs={12} sm={4}>
              {!registration && !this.props.isMarketplace && !this.props.auctionHasEnded
                ? (
                  <LoginLink
                    isLoginModuleEnabled={this.props.isLoginModuleEnabled}
                    redirectUrl={(this.props.isRegisterModuleEnabled === true)
                      ? `/auctions/${auctionUuid}/register`
                      : this.props.isRegisterModuleEnabled}
                    render={(url, isAbsolute) => (
                      <Button block color='primary' href={isAbsolute && url} id='auction__action--register' to={!isAbsolute && url}>
                        {translate('JspPublicCodes_JSP_AUCTION_REGISTRATION')}
                      </Button>
                    )}
                  />
                  )
                : registration && (registration.status === 'ISSUE_WITH_DEPOSIT' || registration.status === 'AWAITING_DEPOSIT')
                  ? (
                  <StripeCheckoutButton
                    apiBaseUrl={this.props.apiBaseUrl}
                    auctionId={auctionId}
                    clientId={this.props.clientId}
                    userId={this.props.userId}
                    depositPayableOnline={auction.depositPayableOnline}
                    block
                    id='auction__action--deposit'
                  >
                    {translate('AuctionRegistrantStatus_AWAITING_DEPOSIT')}
                  </StripeCheckoutButton>
                    )
                  : null}
              {!this.props.isMarketplace
                ? (
                  <Button block color='info' onClick={this.props.onToggleSaleInformationModal} id='auction__action--sale-info'>
                    {translate('JspPublicCodes_JSP_AUCTION_SALE_INFORMATION_VIEW')}
                  </Button>
                  )
                : null}
              <Button block color='secondary' onClick={this.props.onToggleTermsModal} id='auction__action--terms-info'>
                {translate('JspPublicCodes_JSP_AUCTION_TERMS_INFORMATION_VIEW')}
              </Button>
            </Col>
          </Row>
        </header>
        {this.props.socialLinks
          ? (
            <div className='text-right social social__container'>
              <strong className='text-muted social__label'>{translate('JspPublicCodes_JSP_AUCTION_SHARE')}</strong>
              <SocialLinks
                className='social__links'
                url={pageURL}
                title={auction.title}
                description={auction.description}
                {...this.props.socialLinks}
              />
            </div>
            )
          : null}
        <List className='timed-auction__filter'>
          <ListItem className='bg-muted'>
            <MediaQuery minDeviceWidth={768}>
              <button className='a11y__interactive--button' onClick={handleFilterClick} style={{ width: '100%', textAlign: 'left' }}>
                <FontAwesomeIcon
                  icon={!this.state.expandFilter ? faCaretDown : faCaretRight}
                  className='text-primary pull-right timed-auction__filter--icon'
                />
                <strong>{translate('JspPublicCodes_JSP_TIMED_FILTERS')}</strong>
              </button>
              <Collapse in={!this.state.expandFilter}>
                <div>
                  {listingSearchForm}
                </div>
              </Collapse>
            </MediaQuery>
            <MediaQuery maxDeviceWidth={767}>
              <button className='a11y__interactive--button' onClick={handleFilterClick} style={{ width: '100%', textAlign: 'left' }}>
                <FontAwesomeIcon
                  icon={this.state.expandFilter ? faCaretDown : faCaretRight}
                  className='text-primary pull-right timed-auction__filter--icon'
                />
                <strong>{translate('JspPublicCodes_JSP_TIMED_FILTERS')}</strong>
              </button>
              <Collapse in={this.state.expandFilter}>
                <div>
                  {listingSearchForm}
                </div>
              </Collapse>
            </MediaQuery>
          </ListItem>
        </List>
        <Row>
            <Col
              xs={12}
              sm={6}
              md={8}
            >
              <h5 className='auction__results-count text-muted'>
                  {translate('JspPublicCodes_JSP_LISTINGS_COUNT').replace('{0}', filterString.length ? nonGroupedListings.length : paginatedFilteredListings.length)}
              {hasFilters
                ? (
                  <Button size='sm' color='link' className='auction__filters--reset' onClick={this.handleFiltersReset}>
                    {translate('JspPublicCodes_JSP_LISTINGS_FILTERS_CLEAR')}
                  </Button>
                  )
                : null}
                <ButtonGroup>
                  <Button
                    className='auction-view__toggle auction-view__toggle--gallery'
                    title={translate('JspPublicCodes_JSP_UPCOMING_AUCTIONS_GALLERY_VIEW')}
                    active={!this.state.isListLayout}
                    onClick={() => this.setLayoutPreference()}
                  >
                    <FontAwesomeIcon
                      icon={faTh}
                    />
                  </Button>
                  <Button
                    className='auction-view__toggle auction-view__toggle--list'
                    title={translate('JspPublicCodes_JSP_UPCOMING_AUCTIONS_LIST_VIEW')}
                    active={this.state.isListLayout}
                    onClick={() => this.setLayoutPreference(true)}
                  >
                    <FontAwesomeIcon
                      icon={faThList}
                    />
                  </Button>
                </ButtonGroup>
              </h5>
            </Col>
          {userUuid
            ? (
              <Col xs={12} sm={6} md={4} className='filters__container'>
                <ButtonGroup className='timed-auction__filters--state'>
                  <Button
                    onClick={() => this.handleBidStatusFilterUpdate()}
                    className='filters__state filters__state--all' active={!this._query.bstatus || this._query.bstatus === ''}
                  >
                    {translate('MyBidsSearchTypeEnum_ALL')}
                  </Button>
                  <Button
                    onClick={() => this.handleBidStatusFilterUpdate('s')}
                    className='filters__state filters__state--starred'
                    active={this._query.bstatus === 's'}
                  >
                    {translate('SearchFilterCodes_STARRED')}
                    <Badge className='filters__badge filters__badge--starred' color={this.props.listingUuidCountStarred ? 'warning' : 'secondary'}>
                      {this.props.listingUuidCountStarred}
                    </Badge>
                  </Button>
                  <Button
                    onClick={() => this.handleBidStatusFilterUpdate('w')}
                    className='filters__state filters__state--winning'
                    active={this._query.bstatus === 'w'}
                  >
                    {translate('MyBidsSearchTypeEnum_WINNING')}
                    <Badge className='filters__badge filters__badge--winning' color={this.props.listingUuidCountWinning ? 'success' : 'secondary'}>
                      {this.props.listingUuidCountWinning}
                    </Badge>
                  </Button>
                  <Button
                    onClick={() => this.handleBidStatusFilterUpdate('l')}
                    className='filters__state filters__state--losing'
                    active={this._query.bstatus === 'l'}
                  >
                    {translate('MyBidsSearchTypeEnum_LOSING')}
                    <Badge className='filters__badge filters__badge--losing' color={this.props.listingUuidCountLosing ? 'danger' : 'secondary'}>
                      {this.props.listingUuidCountLosing}
                    </Badge>
                  </Button>
                </ButtonGroup>
              </Col>
              )
            : null}
        </Row>
        {enablePaginationTop
          ? (
              <PaginationContainer
                paginationId={'paginationTop'}
                itemPerPageId={'itemsPerPageTop'}
                itemsPerPageOptions={this.props.itemsPerPageOptions}
                hasPagination={hasPagination}
                listingsPerPage={listingsPerPage}
                pageNumber={pageNumber}
                listingCount={listingCount}
                paginationText={paginationText}
                paginationUrl={paginationUrl}
                handlePagination={this.handlePagination}
                setItemsPerPagePreference={this.setItemsPerPagePreference}
              />
            )
          : null}
        <Row className='auction__lots'>
          <PreferenceContext.Provider value={{
            isListLayout: this.state.isListLayout
          }}>
            {!paginatedFilteredListings.length && !paginatedNonGroups.length
              ? (
                <Col xs={12} className='text-center'>
                  <Alert color='warning' className='timed-auction__alert--no-results'>
                    {translate('JspPublicCodes_JSP_AUCTION_DETAILS_NO_RESULTS')}
                  </Alert>
                </Col>
                )
              : listingListItems(paginatedFilteredListings.length && filterString.length ? paginatedFilteredListings : paginatedNonGroups)
            }

          </PreferenceContext.Provider>
        </Row>
        <PaginationContainer
          paginationId={'paginationBottom'}
          itemPerPageId={'itemsPerPage'}
          itemsPerPageOptions={this.props.itemsPerPageOptions}
          hasPagination={hasPagination}
          listingsPerPage={listingsPerPage}
          pageNumber={pageNumber}
          listingCount={listingCount}
          paginationText={paginationText}
          paginationUrl={paginationUrl}
          handlePagination={this.handlePagination}
          setItemsPerPagePreference={this.setItemsPerPagePreference}
        />
      </section>
    )
  }
}

TimedList.propTypes = {
  apiBaseUrl: PropTypes.string.isRequired,
  auctionCategories: PropTypes.object.isRequired,
  auctions: PropTypes.object.isRequired,
  bids: PropTypes.object.isRequired,
  childCategories: PropTypes.object.isRequired,
  countries: PropTypes.object.isRequired,
  clientId: PropTypes.string.isRequired,
  currentLanguageCode: PropTypes.string,
  enablePaginationTop: PropTypes.bool,
  defaultTab: PropTypes.string,
  hasStarted: PropTypes.bool,
  auctionHasEnded: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired
  }).isRequired,
  informations: PropTypes.object.isRequired,
  isLoginModuleEnabled: PropTypes.bool.isRequired,
  isMarketplace: PropTypes.bool.isRequired,
  isRegisterModuleEnabled: PropTypes.bool.isRequired,
  itemsPerPageDefault: PropTypes.number,
  itemsPerPageOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  listings: PropTypes.object.isRequired,
  listingSales: PropTypes.object.isRequired,
  listingsByCategoryUuid: PropTypes.object.isRequired,
  listingsByLocation: PropTypes.object,
  listingUuidCountLosing: PropTypes.number,
  listingUuidCountStarred: PropTypes.number,
  listingUuidCountWinning: PropTypes.number,
  listingUuids: PropTypes.arrayOf(PropTypes.string).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }),
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired,
  parentCategories: PropTypes.object.isRequired,
  onToggleTermsModal: PropTypes.func.isRequired,
  onToggleSaleInformationModal: PropTypes.func.isRequired,
  registrantsByUserUuid: PropTypes.object.isRequired,
  saleStatuses: PropTypes.object.isRequired,
  socialLinks: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    email: PropTypes.bool,
    facebook: PropTypes.bool,
    messenger: PropTypes.bool,
    twitter: PropTypes.bool,
    whatsapp: PropTypes.bool,
    linkedin: PropTypes.bool
  })]),
  userId: PropTypes.number,
  userUuid: PropTypes.string,
  uuid: PropTypes.string.isRequired
}

TimedList.defaultProps = {
  categoryUuids: [],
  continentUuids: [],
  isBiddingRequiredForReserve: false,
  isConsecutiveBiddingDisabled: false
}

export function mapStateToProps (state) {
  return {
    currentLanguageCode: state.config.currentLanguageCode,
    apiBaseUrl: state.config.input.config.apiBase,
    auctionCategories: state.categories.auctionCategories,
    auctions: state.auctions.auctions,
    bids: state.bids.bids,
    childCategories: state.categories.categoryChildren,
    clientId: state.config.input.config.clientId,
    countries: state.countries.countries,
    enablePaginationTop: state.config.input.options.enablePaginationTop,
    informations: state.auctions.information,
    isLoginModuleEnabled: state.config.input.modules.login,
    isRegisterModuleEnabled: state.config.input.modules.register,
    itemsPerPageDefault: state.config.input.options.itemsPerPageDefault,
    itemsPerPageOptions: state.config.input.options.itemsPerPageOptions,
    listings: state.lots.listings,
    listingSales: state.listingSales.sales,
    listingsByCategoryUuid: state.lots.listingsByAuctionByCategoryUuid,
    listingsByLocation: state.lots.listingsByAuctionByLocation,
    parentCategories: state.categories.categoryParents,
    registrantsByUserUuid: state.registrations.registrantIdsByUserUuidByAuction,
    saleStatuses: state.saleStatuses.saleStatuses,
    socialLinks: state.config.input.options.socialLinks,
    userId: state.users.user.id,
    userUuid: state.users.user.uuid
  }
}

export default withRouter(connect(mapStateToProps)(TimedList))
